import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import http from '@/api/http';
export var DICT_URL = 'api/v5/dict';
export function listDict(data, options) {
  return http.get(DICT_URL, data, options).then(function (response) {
    return response.data;
  });
}
export function getDictById(id, data, options) {
  return http.get("".concat(DICT_URL, "/").concat(id), data, options).then(function (response) {
    return response.data;
  });
}
export function listDictTypes(data, options) {
  return http.get("".concat(DICT_URL, "/type"), data, options).then(function (response) {
    return response.data;
  });
}
export function createDict(data, options) {
  return http.post(DICT_URL, data, options);
}
export function updateDictById(id, data, options) {
  return http.put("".concat(DICT_URL, "/").concat(id), data, options);
}
export function removeDictById(id, data, options) {
  return http.destroy("".concat(DICT_URL, "/").concat(id), data, options);
}

// mixin
export default {
  data: function data() {
    return {
      dict: {
        list: [],
        page: 1,
        size: 10,
        total: 0,
        model: null
      }
    };
  },
  /**
   * Mixin方法
   */
  methods: {
    // 查询所有数据
    fetchDict: function fetchDict() {
      var _this = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data,
        options = _ref.options;
      return listDict(data, options).then(function (response) {
        var list = response.list,
          total = response.total;
        _this.dict.list = list;
        _this.dict.total = total;
        return response;
      });
    },
    // 查询单个数据
    getDict: function getDict() {
      var _this2 = this;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref2.id,
        data = _ref2.data,
        options = _ref2.options;
      return getDictById(id, data, options).then(function (response) {
        _this2.dict.model = Object.assign({}, data, response || {});
        return response;
      });
    },
    // 删除数据
    removeDict: function removeDict() {
      var _this3 = this;
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref3.id,
        data = _ref3.data,
        index = _ref3.index,
        options = _ref3.options;
      return removeDictById(id, data, options).then(function (response) {
        var list = _toConsumableArray(_this3.dict.list);
        if (index !== undefined) {
          list.splice(index, 1);
        }
        _this3.dict.list = list;
        _this3.dict.total -= 1;
        return response;
      });
    }
  }
};